import { inject, Injectable } from '@angular/core';

import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { AlertController } from '@ionic/angular';

import { saveAs } from 'file-saver';
import { v4 } from 'uuid';

import { LoadingService } from './loading.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private alertController = inject(AlertController);
  private loadingService = inject(LoadingService);

  async exportDocument(pdfBlob: Blob, fileName: string, title: string, dialogTitle = 'Export Report') {
    if (Capacitor.isNativePlatform()) {
      const { value } = await Share.canShare();
      if (value) {
        const id = v4();
        this.loadingService.setLoading(id, true);
        const { uri } = await Filesystem.writeFile({
          data: await new Promise<string>((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.readAsDataURL(pdfBlob);
          }),
          directory: Directory.Data,
          path: fileName
        });
        this.loadingService.setLoading(id, false);
        await Share.share({
          dialogTitle,
          files: [uri],
          title
        });
      } else {
        const alert = await this.alertController.create({
          backdropDismiss: false,
          buttons: [
            {
              role: 'cancel',
              text: 'Ok'
            }
          ],
          header: 'Share File',
          message: 'We are sorry but share functionality is not available on your device.'
        });
        await alert.present();
      }
    } else {
      saveAs(pdfBlob, fileName);
    }
  }
}
